export { default as TabsCDS } from './TabsCDS';
